import { render, staticRenderFns } from "./ClinicalData.vue?vue&type=template&id=f259f422&scoped=true"
import script from "./ClinicalData.vue?vue&type=script&lang=js"
export * from "./ClinicalData.vue?vue&type=script&lang=js"
import style0 from "./ClinicalData.vue?vue&type=style&index=0&id=f259f422&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f259f422",
  null
  
)

export default component.exports